import styled from "styled-components";
import icoBorra from "../../assets/simb-borra.png";
import icoFert from "../../assets/baby.svg";
import icoRelac from "../../assets/simb-hearth.png";

export const Container = styled.div<{ edit : boolean, fullSpace : boolean }>`
    display: flex;
    cursor: ${props => props.edit ? 'pointer' : 'inherit'};

    ${props => props.fullSpace && 'width: 100%'};
    ${props => props.fullSpace && 'height: 100%'};
    ${props => props.fullSpace && 'position: absolute'};
    ${props => props.fullSpace && 'top: 0'};
    ${props => props.fullSpace && 'left: 0'};
    ${props => props.fullSpace && 'margin: 0'};

    div.regranull, div.regra, div.regran0{
        background: transparent;
        width: 21px;
        height: 20px;
        border: dashed 1px rgba(0,0,0,0.5);
        border-radius: 5px;
        opacity: 0.3;
        display: ${props => props.edit ? 'block' : 'none'};
        
        &::before{
            content: 'ADD';
            font-size: 0.49rem;                        
            display: flex;
            justify-content: center;
            align-items: center;
            align-content: center;
            flex:1;
            padding-top: 5px;
        }

        &:hover{
            opacity: 0.7;
            transition: 0.9s;
            background: var(--darkblue);
            color: #fff;
        }
    }
`
// simbolo da regra
export const Simbol = styled.div<{temselo?: boolean, selo?: number}>`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    z-index: 2;

    div.regranull{
        display: ${props => props.temselo ? 'none' : 'block'};
    }

    div.regra1{
        background: var(--darkblue);
        width: 10px;
        height: 10px;
        border-radius: 50%;
        display: block;
        box-shadow: 1px 1px 3px -1px rgb(0 0 0 / 65%);
    }
    div.regra2{
        background: url(${icoBorra}) no-repeat center top;
        width: 16px;
        height: 12px;
        display: block;   
        margin-bottom: 4px;
        margin-top: 0px;
        margin-left: -3px;
        margin-right: -3px;
        filter: ${props => props.selo === 4 ? 'invert(18%) sepia(93%) saturate(5909%) hue-rotate(357deg) brightness(102%) contrast(115%)' : ''};
    }
    div.regra3{
        background: var(--darkblue);
        width: 11px;
        height: 3px;
        border-radius: 5px;        
        box-shadow: 1px 1px 3px -1px rgb(0 0 0 / 65%);
        top: -3px;
        margin: 6px 0;

        &::before{
            content: '.';
            background: var(--darkblue);
            width: 100%;
            height: 3px;
            border-radius: 5px;
            top: 6px;
            box-shadow: 1px 1px 3px -1px rgb(0 0 0 / 65%); 
            font-size: 1px;
            display: block;
            position: absolute;
        }
    }
    div.regra4{
        background: var(--darkblue);
        width: 3px;
        height: 11px;
        border-radius: 5px;        
        box-shadow: 1px 1px 3px -1px rgb(0 0 0 / 65%);
        margin: 3px 0;
    }
    div.regra5{
        background: transparent;
        border: solid 2px var(--darkblue);
        width: 11px;
        height: 11px;
        aspect-ratio: 1/1;
        border-radius: 50%;
        display: block;
        margin: 1;
    }
    div.regra6{ 
        display: flex;      
        flex: 1;
        justify-content: center;
        margin-top: -3px;
        overflow: hidden;

        &::before{
            content: "✖";
            font-size: 0.8rem;
            font-weight: 900;
            margin-top: 1px;
        }
    }
    div.regra7, div.regra8, div.regra9{ 
        display: flex;      
        flex: 1;
        justify-content: center;

        &::before{
            content: "1";
            /*font-family: 'Lilita One', Calibri, cursive;*/
            font-size: 0.8rem;
            line-height: 0.8rem;
            font-weight: 900;
            /*font-style: italic;*/
            /*margin-right: 3px;*/
        }
    }
    div.regra8{ 

        &::before{
            content: "2";
        }
    }
    div.regra9{
        &::before{
            content: "3";
        }
    }

    div.regra11{
        background: url(${icoFert}) no-repeat center center;
        width: 16px;
        height: 16px;
        display: block;
        flex: none;
    }



`

// Fertilidade
export const Fertilidade = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    z-index: 2;

    div.regra5{
        background: transparent;
        border: solid 2px var(--darkblue);
        width: 11px;
        height: 11px;
        border-radius: 50%;
        aspect-ratio: 1/1;
        display: block;
        box-shadow: 1px 1px 3px -1px rgb(0 0 0 / 65%);
        margin: 2px 0 1px;
    }
    div.regra11{
        background: url(${icoFert}) no-repeat center center;
        background-size: contain;
        width: 12px;
        height: 20px;
        display: block;
        margin-top: 4px;
        margin-bottom: 2px;
    }
`

// Selos
export const Selo = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;  
    
    z-index : 1;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    opacity: 0.85;

    div.regra1, div.regra2, div.regra3, div.regra4{
        background: #FF5050;
        //width: 0.9rem;
        //height: 0.9rem;
        //width: calc(200% + 9px);
        width: 100%;
        height: calc(100% - 4px);
        /*aspect-ratio: 1/1.1;*/
        border-radius: 4px;
        display: block;
        box-shadow: 1px 1px 3px -1px rgb(0 0 0 / 30%);
        position: absolute;
        left: 0px;
    }
    div.regra2{
        background: #FFCE3C;
    }
    div.regra3{
        background: #00C382;
    }
    div.regra4{
        background: #f0ede7;
    }

    div.regranull{
        border: unset;
    }
    div.regranull::before{
        content: '';
    }

    .fullColor{
      position: absolute;
    }
    
`

// Relações
export const Relacao = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;   

    div.regra1{
        background: url(${icoRelac}) no-repeat center center;
        width: 18px;
        height: 20px;
        display: block;
    }
`

// RegraDia
export const RegraDia = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    z-index: 2;

    div.regra1, div.regra2, div.regra3, div.regra4{      
        display: flex;      
        flex: 1;
        justify-content: center;
        align-items: center;

        &::before{
            content: "R1";
            font-family: 'Roboto Condensed', Calibri, cursive;
            font-size: 0.8rem;
            font-weight: 400;
            font-style: italic;
            margin-right: 3px;
            
        }
    }
    div.regra2{ 

        &::before{
            content: "R2";
        }
    }
    div.regra3{ 
        &::before{
            content: "R3";
        }
    }
    div.regra4{
        &::before{
            content: "RA";
        }
    }
`

export const RelacaoR = styled.span`
    font-size: 0.8rem;
    line-height: 0.8rem;
    width: 100%;
    text-align: center;
    display: inline-block;
    font-weight: 900;
    color: var(--darkblue);
    line-height: 1;
    flex: none;
    letter-spacing: -0.5px;
    margin-top: 0px;
`

export const ViewPosition = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 4;
`